import { render } from "./view-stock-adjustment.vue?vue&type=template&id=5d29d79a&scoped=true"
import script from "./view-stock-adjustment.vue?vue&type=script&lang=js"
export * from "./view-stock-adjustment.vue?vue&type=script&lang=js"

import "./view-stock-adjustment.vue?vue&type=style&index=0&id=5d29d79a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d29d79a"]])

export default __exports__